module.exports = __webpack_public_path__ + "static/media/upload-background.d4e1d59d.jpeg";